import classNames from 'classnames';

import useWindowDimensions from 'hooks/useWindowDimensions';
import SingleTextLoader from 'organisms/Loaders/SingleTextLoader';

export default function ({ item, isLoading }) {
  const { width } = useWindowDimensions();
  const isMobile = width < 500;
  if (isLoading) return <SingleTextLoader />;

  return (
    <p className={classNames(isMobile && 'f12')}>{item.datePaid || '-'}</p>
  );
}
